/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable eqeqeq */
import React, { Component } from 'react'
import { withDomains, RESTExecutor } from '../../lib/domain'
import { Tag, Row, Table, Button, Tooltip, Collapse, Select, Checkbox, DatePicker, Input, InputNumber, Popover, Badge, Divider, Modal } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import ErrorWrapper from '../../lib/error_wrapper';
import moment from 'moment';
import { formatMoney, showErrorInNotification, defaultDateFormat, THEME_COLORS } from '../../lib/util';
import CustomDateRangePicker from '../../components/custom_date_range';
import ModalTransactionDetail from '../../components/modal_transaction_detail';
import lodash from 'lodash';
import { NetworkDelaySearch } from '../../lib/util';
import { Spin } from 'antd';
import { PageHeader } from 'antd';
import { BasicHeader } from '../../components/basic_header';
import NetworkSelect from '../../lib/ui/network_select';
import FilterFixedInput from '../../components/filter_fixed_input';
import { FilterNone, MoreHorizOutlined } from '@material-ui/icons';
import { TransparentButton } from '../../components/basic_items';
import { InsertDriveFileOutlined } from '@material-ui/icons';
import { LayersOutlined } from '@material-ui/icons';
import { WifiTetheringOutlined } from '@material-ui/icons';
import { ErrorOutline } from '@material-ui/icons';
import { COLORS } from '../theme';
import ExternalFilterClear from '../../components/external_filter_clear';

const { Panel } = Collapse;
const { RangePicker } = DatePicker;
const queryString = require('query-string');

const MAX_RECON_SHOW = 7;
const MAX_RECON_ITEM_WIDTH = 100;

const customPanelStyle = {
    background: '#FFFFFF',
    borderRadius: 6,
    marginBottom: 12,
    border: 0,
    overflow: 'hidden',
};

let transaction_list_state = null;

const transaction_cols_new = ({ onServiceClicked, onSourceClicked, onViewDetailClicked }) => [
    {
        title: "TYPE",
        dataIndex: "type",
        key: "type",
        className: 'center-align',
        width: 53,
        render: (value, row, index) => {
            return <div title={value == 'C' ? "Credit" : (value == 'D' ? "Debit" : "N/A")} className={value === 'D' ? 'debit-circle' : value == 'C' ? 'credit-circle' : 'na-circle'}>
                {value || "-"}
            </div>
        }
    }, {
        title: "TXN DATE",
        dataIndex: "txn_date",
        key: "txn_date",
        width: 100,
    }, {
        title: "TXN ID",
        dataIndex: "transaction_id",
        key: "transaction_id",
        width: 120,
    }, {
        title: "PARTICULARS ",
        dataIndex: "description",
        key: "description",
        // width: 500,
        className: 'word-break',
        render: (value, row, index) => {
            return <span>
                {row.batch_id && <FilterNone
                    className='batch-indicator'
                    titleAccess="Batched"
                    style={{
                        marginRight: 8
                    }}
                />}
                {value}
            </span>
        }
    },
    // {
    //     title: "Amount",
    //     dataIndex: "amount",
    //     key: "amount",
    //     width: 120,
    // },
    {
        title: "SERVICE",
        key: 'service',
        width: 240,
        render: (value, row, index) => {
            let service_name = row.service_name;
            let service_color = row.color_code || 'grey';
            return <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {/* <div style={{ minHeight: 6, minWidth: 6, borderRadius: 3, backgroundColor: service_color, marginRight: 6 }}></div> */}
                <div
                    className='hoverable-text hand-cursor'
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        typeof onServiceClicked === 'function' && onServiceClicked(row.data_service_id || 'unclassified')

                    }}
                // style={{ flex: 1 }}
                >{service_name || "Unknown Service"}</div>

            </div>
            // <Badge className='faded-text-badge' color={service_color} text={service_name || "Unknown Service"} />
        }
    }, {
        title: "SOURCE Label",
        dataIndex: "source_id",
        key: "source_id",
        width: 200,
        render: (value, row) => <div
        // className='hoverable-text'
        // onClick={(e) => {
        //     e.preventDefault();
        //     e.stopPropagation();
        //     typeof onSourceClicked === 'function' && onSourceClicked(value)

        // }}
        >
            {value}
        </div>
        // width: 120,
        // render:(value,row,index)=>formatMoney(value, 2, '.', ',')
    }, {
        title: "AMOUNT",
        dataIndex: "amount",
        key: "amount",
        width: 130,
        className: 'right-align',
        render: (value, row, index) => formatMoney(value, 2, '.', ',')
    },
    {
        title: "",
        width: 40
    },
    {
        title: "PROCESSING",
        key: 'reconcilers',
        width: 80,
        render: (row, index) => {
            let unrecon_process = row.unreconciled_groups || [];
            let total_recon_process = row.reconcilers || [];

            return <div style={{
                display: 'flex', flexDirection: 'row',
                width: 40,
                flexWrap: 'wrap'
            }}>
                {total_recon_process.map((item, index) => {
                    let name = item.name;
                    let reconciled = item.reconciled;
                    let is_exclusion = item.exclusion
                    let is_peer_of_reconciled = item.batched;

                    return <Tooltip className='test-class' arrowPointAtCenter placement='topRight' title={name} key={index} >
                        <div
                            className={reconciled ? is_peer_of_reconciled ? 'reconciled-indicator-for-parentbatch' : is_exclusion ? 'reconciled-indicator-with-exclusion' : 'reconciled-indicator' : 'not-reconciled-indicator'}
                        ></div>
                    </Tooltip>
                })}
            </div>

        }

    },
    {
        title: "",
        dataIndex: 'id',
        key: 'id',
        width: 40,
        render: (id) => {
            return <MoreHorizOutlined
                titleAccess='View Detail'
                className='basic-icon hand-cursor' onClick={() => {
                    console.log("detail clicked")
                    typeof onViewDetailClicked === 'function' && onViewDetailClicked(id)
                }} />
        }
    }

]
const transaction_cols = ({ props, sort_order = [], onDatatypeClick, onServiceClick, onViewDetailClicked }) => [
    {
        // title: "Type",
        dataIndex: "type",
        key: "type",
        width: 25,
        render: (value, row, index) => {
            const obj = {
                children: <div style={{ backgroundColor: value == 'C' ? '#4062BB' : '#4E937A' }} className='dr-cr-text'>
                    {value}
                </div>,
                props: {},
            };
            if (index % 2 !== 0) {
                obj.props.colSpan = 0;
                return obj
            } else {
                obj.props.className = 'no-bottom-1'
            }
            return obj;
        },

    },
    {
        title: "Txn Date",
        dataIndex: "formatted_txn_date",
        key: "formatted_txn_date",
        width: 120,
        render: (value, row, index) => {
            const obj = {
                children: value,
                props: {},
            };

            if (index % 2 !== 0) {
                let datatype_name = row.data_type_name;
                let service_name = row.service_name;
                let service_color = row.service_color_code || 'grey';
                let unrecon_process = row.unreconciled_groups || []; //["HAHAHA","HAHA","HAHAHAHAHAHA"];
                let total_recon_process = row.reconcilers || [];//["HAHAHA","HUHUHU","HAHA","HUHUHUHU","HAHAHAHAHAHA"];

                obj.props.colSpan = 6;
                obj.children = <Row type='flex' justify='space-between'>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    }}>
                        {/* {row.batch_id && <Tooltip title="Batched Transaction">
                            <Icon style={{ marginRight: 8 }} type="snippets" theme="twoTone" /></Tooltip>} */}
                        {(props.query_params && props.query_params.datatype) && true ?
                            null :
                            <Tag className='hand-cursor' onClick={() => {
                                // typeof onDatatypeClick==='function'&&onDatatypeClick(row.data_type_id)
                            }} > <Badge className='faded-text-badge' status='default' text={datatype_name || "Unknown Datatype"} /></Tag>
                        }
                        {(props.query_params && props.query_params.service) && false ?
                            null :
                            <Tag style={{ display: 'flex' }} className='hand-cursor' onClick={(e) => {
                                console.log("service clicked")
                                // typeof onServiceClick === 'function' && onServiceClick(row.data_type_id, row.data_service_id)
                            }} >
                                <Badge className='faded-text-badge' color={service_color} text={service_name || "Unknown Service"} />
                            </Tag>
                        }
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    }}>
                        {total_recon_process.map((item, index) => {
                            if (index < MAX_RECON_SHOW) {
                                return <Tooltip title={item} key={index} ><Tag
                                    style={{ display: 'flex' }}
                                ><Badge className='faded-text-badge' style={{
                                    maxWidth: MAX_RECON_ITEM_WIDTH,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }} status={!(unrecon_process.includes(item)) ? 'success' : 'error'} text={item} /></Tag></Tooltip>
                            }
                        })}
                        {(total_recon_process.length - 1) > MAX_RECON_SHOW && <Popover
                            trigger='click'
                            placement='bottomRight' content={
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    {total_recon_process.map((item, index) => {
                                        if (index >= MAX_RECON_SHOW) {
                                            return <Tooltip title={item} key={index} ><Tag
                                                // color={recon_process.includes(item)?'green':'red'}
                                                style={{
                                                    display: 'flex',
                                                    marginTop: 4,

                                                    marginBottom: 4,

                                                }}><Badge className='faded-text-badge' style={{
                                                    maxWidth: MAX_RECON_ITEM_WIDTH,
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }} status={!(unrecon_process.includes(item)) ? 'success' : 'error'} text={item} /></Tag></Tooltip>
                                        }
                                    })}
                                </div>}>
                            {/* <Icon type="caret-down" /> */}
                        </Popover>}
                        <Divider type='vertical' />
                        <Link to={`/processors/${row.id}`} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            typeof onViewDetailClicked === 'function' && onViewDetailClicked(row.id)
                        }}>
                            <Button style={{ padding: 0 }} type='link'>Detail</Button>
                        </Link>
                    </div>

                </Row>
            } else {
                obj.props.className = 'no-bottom-1'
            }
            return obj;
        },

    },
    {
        title: "Tran ID",
        dataIndex: "transaction_id",
        key: "transaction_id",
        width: 100,
        render: (value, row, index) => {
            const obj = {
                children: value,
                props: {},
            };
            if (index % 2 !== 0) {
                // console.log("index", index)
                obj.props.colSpan = 0;
                return obj;
            } else {
                obj.props.className = 'no-bottom-1'
            }

            return obj;
        },
    },
    {
        title: "Particular",
        dataIndex: "description",
        key: "description",
        className: 'word-break',
        render: (value, row, index) => {
            const obj = {
                children: value,
                props: {},
            };
            if (index % 2 !== 0) {
                // console.log("index", index)
                obj.props.colSpan = 0;


                return obj;
            }
            else {
                obj.props.className = 'no-bottom-1'
            }
            return obj;
        },
    },
    {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
        width: 120,
        // sorter: true,
        render: (value, row, index) => {
            const obj = {
                children: formatMoney(value, 2, '.', ','),
                props: {},
            };
            if (index % 2 !== 0) {
                // console.log("index", index)
                obj.props.colSpan = 0;
                return obj
            } else {
                obj.props.className = 'no-bottom-1'
            }
            return obj;
        },

    },
]
class TransactionList extends Component {
    constructor(props) {
        super(props)

        let query_params = this.props.query_params || {};

        //If has previous filters and data, dont call network
        let should_fetch_data = true;
        // if(transaction_list_state
        //     &&props.history
        //     &&props.history.action=='POP' 
        //     &&transaction_list_state.main_query
        //     &&query_params.datatype==transaction_list_state.main_query.datatype
        // ){
        //     should_fetch_data=false;
        //     this.state={
        //         ...transaction_list_state,

        //     }
        //     }else{
        this.state = {

            transaction_list: [],
            transaction_meta: {},

            view_transaction_id: null,
            view_transaction_modal: false,

            filters: {},
            props_query: this.props.query_params || {},
            main_query: {
                per_page: 100,
                page: 1,
                dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                dateTo: moment().format(defaultDateFormat),
                ...query_params
            },
            dateFilterType: 'range',
            amountFilterType: 'value',
            loading: true,
            datatype: {}

        };
        // }

        this.list_transaction = RESTExecutor
            .list()
            .config({
                label: 'transactions', params: {
                    // ...this.props.query_params,
                    ...this.getParams(),
                }
            })
            .callbacks((success) => {
                this.setState({
                    transaction_list: success.result.rows,// this.partitionTransaction(success.result.rows),
                    transaction_meta: success.meta
                });

                // console.log("changing transation list", this.partitionTransaction(success.result.rows))
            }, (error) => {
                showErrorInNotification(error)
            })
            .connect(props.domains.allData);



        this.detail_datatype = RESTExecutor.list().config({
            label: 'datatypes_details',
        }).forId(query_params.datatype).callbacks((success) => {
            let item = success.result;
            this.setState({ loading: false, datatype: success.result });
            this.list_transaction.execute();

        }, (error) => {
            this.setState({ loading: false });

            showErrorInNotification(error);
        }).connect(props.domains.allData);






        // if(should_fetch_data){

        this.detail_datatype.execute();




        this.delay_search = new NetworkDelaySearch();


    };

    getParams = () => {
        let params = JSON.parse(JSON.stringify(this.state.main_query));

        if (params['service'] == 'unclassified') {
            params['uncategorized'] = true;
            params['service'] = null;
        } else {
            params['uncategorized'] = null;
        }

        if (params['batched'] === 'false') {
            delete params['batched'];
            params['not_batched'] = 'true'
        };


        console.log("transactions for params", params)
        return params
    }

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    handleTableChange = (pagination, filters, sorter) => {
        console.log("sorter", sorter, pagination);
        let order = [];
        let orderProps = {};
        orderProps = {
            order: JSON.stringify(order)
        }
        if (order.length === 0) {
            orderProps = {}
        }


        this.stateUpdater({
            stateKey: 'main_query',
            appendObj: {
                per_page: pagination.pageSize,
                page: pagination.current,
                ...orderProps
            },
            callback: () => {
                console.log("calling")
                this.props.history.push({
                    search: queryString.stringify(this.state.main_query)
                })
                // this
                //     .list_transaction
                //     .config({
                //         params: {
                //             ...this.getParams(),
                //             // ...this.state.props_query
                //         }
                //     })
                //     .execute();
            }
        });
    }


    render() {
        let list_transaction_resp = this
            .list_transaction
            .response();

        if (this.state.loading) {
            return <center><Spin /></center>
        }

        const { main_query, transaction_meta, props_query } = this.state;
        let detail_datatype_resp = this.detail_datatype.response();
        // let datatype_list = (list_datatype_resp.result && list_datatype_resp.result.rows) || [];



        return (
            <ErrorWrapper error={detail_datatype_resp}
                onReload={() => {
                    this.detail_datatype.execute()
                }}>

                <BasicHeader
                    title={this.state.datatype.name}
                    titleType="Datatype"
                    subtitle="Transactions"
                    right={[
                        <Link to={`/activity/data-type/${main_query.datatype}/unclassifiedtransactions`} >
                            <TransparentButton
                                iconStyle={{
                                    color: COLORS.danger_primary
                                }}
                                labelStyle={{
                                    color: COLORS.danger_primary
                                }}
                                className={main_query.service === 'unclassified' ? 'ripple-btn' : null}
                                label="Unclassified"
                                icon={<ErrorOutline />}
                                hint="View Unclassified"
                            />
                        </Link>,
                        <Link to={`/activity/data-type/${main_query.datatype}/files`} >
                            <TransparentButton
                                label="Files"
                                icon={<InsertDriveFileOutlined />}
                                hint="View Files"
                            />
                        </Link>,
                        <Link to={`/activity/data-type/${main_query.datatype}/packets`} >
                            <TransparentButton
                                label="Packets"
                                icon={<LayersOutlined />}
                                hint="View Packets"
                            />
                        </Link>,
                        <Link to={`/activity/data-type/${main_query.datatype}/sources`} >
                            <TransparentButton
                                label="Sources"
                                icon={<WifiTetheringOutlined />}
                                hint="View Sources"
                            />
                        </Link>
                    ]}
                />
                {/* <PageHeader
                style={{backgroundColor:'white',marginBottom:12}}
                ghost={false}
                // onBack={() => window.history.back()}
                title={this.state.datatype.name}
                subTitle="Transaction"
                extra={[
                    <Link to={`/recon/data-type/${main_query.datatype}/files`}><Button type='primary' icon='file' key="3">Files</Button></Link>,
                    <Link to={`/recon/data-type/${main_query.datatype}`}><Button type='primary' icon='container' key="2">Repository</Button></Link>,
                
                ]}
                ></PageHeader> */}


                {/* FILTER SECTION  START*/}
                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                        <Input.Search
                            placeholder="Input search text"
                            // enterButton
                            allowClear
                            autoFocus
                            value={main_query.query}
                            style={{}}
                            onChange={(e) => {
                                e.stopPropagation();
                                e.preventDefault()
                                this.stateUpdater({
                                    stateKey: 'main_query', valueKey: 'query', value: e.target.value, callback: () => {
                                        this.delay_search.onSearch(() => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.main_query, per_page: 100, page: 1 })
                                            })
                                        })
                                    }
                                });
                            }}
                        />
                        <CustomDateRangePicker
                            style={{
                                width: 400,
                                marginLeft: 16,
                                flex: null
                            }}
                            startDate={moment(main_query.dateFrom, defaultDateFormat)}
                            endDate={moment(main_query.dateTo, defaultDateFormat)}
                            onChange={(dates) => {
                                //   console.log("GOT DATES",dates.startDate.toISOString(),dates.endDate.toISOString())
                                this.stateUpdater({
                                    stateKey: 'main_query', appendObj: {
                                        dateFrom: dates.startDate.format(defaultDateFormat),
                                        dateTo: dates.endDate.format(defaultDateFormat),
                                        per_page: 100, page: 1
                                    },
                                    callback: () => {
                                        this.props.history.push({
                                            search: queryString.stringify(this.state.main_query)
                                        })
                                        // this.list_transaction.config({
                                        //     params: {
                                        //         ...this.getParams(),
                                        //         per_page:20,
                                        //         page:1
                                        //     }
                                        // }).execute()
                                    }
                                })

                                // this.setState({
                                //     startDate: dates.startDate,
                                //     endDate: dates.endDate
                                // })
                            }}

                        />
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        // justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        paddingTop: 4, paddingBottom: 4
                    }}>
                        <FilterFixedInput label="Source Label">
                            <NetworkSelect
                                value={main_query.source}
                                style={{ marginRight: 8 }}
                                item={{ name: "Source Label", display_key: 'source_id', item_key: "source_id", className: main_query.source != null ? 'filter-option-selected' : '' }}
                                url={`/my-data-types/${props_query.datatype}/staging-info/source-labels`}
                                onChange={(received_value) => {
                                    this.stateUpdater({
                                        stateKey: 'main_query',
                                        valueKey: 'source',
                                        value: received_value,
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.main_query, per_page: 100, page: 1 })
                                            })
                                        }
                                    })
                                    // this._change(item.index, received_value, d_key)
                                }}
                            // renderItem={(data)=>{
                            //     // console.log("data",data)
                            //     let ref = data.__references__ || {};
                            //     let source = ref.source_id || {};
                            //     return source.name
                            //   }}

                            /></FilterFixedInput>
                        <FilterFixedInput label="Service">
                            <NetworkSelect
                                value={main_query.service}
                                style={{ marginRight: 8 }}
                                item={{ name: "Service", className: main_query.service != null ? 'filter-option-selected' : '' }}
                                url={`/my-data-types/${props_query.datatype}/services`}
                                additional_options={[
                                    <Select.Option value={'unclassified'} key={'unclassified'}>
                                        Unclassified
                                    </Select.Option>
                                ]}
                                onChange={(received_value) => {
                                    this.stateUpdater({
                                        stateKey: 'main_query',
                                        valueKey: 'service',
                                        value: received_value,
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.main_query, per_page: 100, page: 1 })
                                            })
                                        }
                                    })
                                    // this._change(item.index, received_value, d_key)
                                }}
                            /></FilterFixedInput>
                        <FilterFixedInput label="Label">
                            <NetworkSelect
                                value={main_query.label}
                                style={{ marginRight: 8 }}
                                item={{ name: "Label", className: main_query.label != null ? 'filter-option-selected' : '' }}
                                url={`/my-data-types/${props_query.datatype}/flags`}
                                onChange={(received_value) => {
                                    this.stateUpdater({
                                        stateKey: 'main_query',
                                        valueKey: 'label',
                                        value: received_value,
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.main_query, per_page: 100, page: 1 })
                                            })
                                        }
                                    })
                                    // this._change(item.index, received_value, d_key)
                                }}
                            /></FilterFixedInput>

                        <FilterFixedInput label="Batched">
                            <Select
                                allowClear
                                className={main_query.batched != null ? 'filter-option-selected' : ''}
                                showSearch
                                style={{
                                    marginRight: 8,
                                    width: '100%'
                                }}
                                // style={{ marginTop:4,marginBottom:4 }}
                                placeholder="Batched"
                                value={main_query.batched}
                                // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(value, e) => {
                                    this.stateUpdater({
                                        stateKey: 'main_query',
                                        valueKey: 'batched',
                                        value: value,
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.main_query, per_page: 100, page: 1 })
                                            })
                                        }
                                    });
                                }}
                            >
                                <Select.Option value={"true"} key={"true"}>Batched </Select.Option>
                                <Select.Option value={"false"} key={"false"}>Unbatched </Select.Option>
                            </Select>
                        </FilterFixedInput>
                        <FilterFixedInput label="Txn Type">
                            <Select
                                allowClear
                                className={main_query.txn_type != null ? 'filter-option-selected' : ''}
                                showSearch
                                style={{
                                    marginRight: 8,
                                    width: '100%'
                                }}
                                // style={{ marginTop:4,marginBottom:4 }}
                                placeholder="Txn Type"
                                value={main_query.txn_type}
                                // filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                onChange={(value, e) => {
                                    this.stateUpdater({
                                        stateKey: 'main_query',
                                        valueKey: 'txn_type',
                                        value: value,
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.main_query, per_page: 100, page: 1 })
                                            })
                                        }
                                    });
                                }}
                            >
                                <Select.Option value={"D"} key={"D"}>
                                    Debit
                                </Select.Option>
                                <Select.Option value={"C"} key={"C"}>
                                    Credit
                                </Select.Option>
                                <Select.Option value={"N/A"} key={"N/A"}>
                                    N/A
                                </Select.Option>
                            </Select>
                        </FilterFixedInput>
                    </div>
                </div>
                {/* FILTER SECTION  END*/}
                <ExternalFilterClear
                    filters={main_query}
                    staticKeys={['dateFrom', 'dateTo', 'txn_type', 'batched', 'label', 'service', 'source_id', 'datatype', 'source']}
                    onClear={(new_filters) => {
                        this.props.history.push({
                            search: queryString.stringify(new_filters)
                        })
                    }}
                />
                <ErrorWrapper
                    error={list_transaction_resp}
                    onReload={() => {
                        this.list_transaction.execute()
                    }}
                >
                    <Modal
                        visible={this.state.view_transaction_modal}
                        width={'90%'}
                        destroyOnClose
                        footer={null}
                        className='transaction-modal'
                        centered
                        onCancel={() => {
                            this.setState({
                                view_transaction_modal: false,
                                view_transaction_id: null
                            })
                        }}
                    >
                        <ModalTransactionDetail
                            isModal={true}
                            onClose={() => {
                                this.setState({
                                    view_transaction_modal: false,
                                    view_transaction_id: null
                                })
                            }}
                            match={{
                                params: {
                                    transaction_id: this.state.view_transaction_id
                                }
                            }}
                        />
                    </Modal>

                    <div id="searchResult"
                        className='default-card'
                        style={{
                            // margin: 0,
                            // marginTop: 20,
                            overflow: 'hidden',
                            padding: 0
                        }}>
                        <Table
                            size='small'
                            scroll={{ x: true }}
                            className='main-table'
                            bordered={false}
                            loading={list_transaction_resp.fetching}
                            rowKey={(record, index) => `${record.id}-${index}`}
                            style={{
                                // backgroundColor: 'white'
                            }}
                            dataSource={this.state.transaction_list}
                            columns={transaction_cols_new({
                                onServiceClicked: (received_value) => {
                                    this.stateUpdater({
                                        stateKey: 'main_query',
                                        valueKey: 'service',
                                        value: `${received_value}`,
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.main_query, per_page: 100, page: 1 })
                                            })
                                        }
                                    })
                                },
                                onViewDetailClicked: (id) => {
                                    this.setState({
                                        view_transaction_modal: true,
                                        view_transaction_id: id
                                    })
                                },
                                onSourceClicked: (received_value) => {
                                    this.stateUpdater({
                                        stateKey: 'main_query',
                                        valueKey: 'source',
                                        value: `${received_value}`,
                                        callback: () => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.main_query, per_page: 100, page: 1 })
                                            })
                                        }
                                    })
                                }
                            })}
                            onChange={this.handleTableChange}
                            pagination={{
                                position: 'bottom',
                                pageSizeOptions: ["10", "20", "40", "60", "100"],
                                defaultCurrent: 1,
                                current: transaction_meta.pagination && parseInt(transaction_meta.pagination.split('/')[0]),
                                pageSize: (transaction_meta && transaction_meta.requested_count),
                                total: (transaction_meta && transaction_meta.total_count == 10001 ? 10000 : transaction_meta.total_count),
                                showTotal: (total, range) => `${formatMoney(range[0], 0)}-${formatMoney(range[1], 0)} of ${transaction_meta.total_count > 10000 ? `10,000+` : `${formatMoney(transaction_meta.total_count, 0)}`} items`
                            }}
                        />
                    </div>
                </ErrorWrapper>
            </ErrorWrapper>
        )
    }

    partitionTransaction = (list_data = []) => {
        let new_list = [];

        list_data.map((item) => {
            new_list.push(item);
            new_list.push(item);
        });

        return new_list;
    }

    componentDidMount() {
        try {
            window.header_assigner.assignTitle(`loading`);
        } catch (e) {

        }
    }

    componentWillUnmount = () => {
        // transaction_list_state=this.state;
    }
    componentWillReceiveProps(nextProps) {
        // var oldQuery = this.props.query_params;
        // console.log("location",this)
        var oldpropsQuery = this.props.query_params;
        let newQuery = nextProps.query_params;

        console.log("new query", newQuery, oldpropsQuery)
        if (!lodash.isEqual(newQuery, oldpropsQuery)) {
            console.log("props changes", newQuery)
            this.setState({
                main_query: {
                    //   ...this.state.main_query,
                    dateFrom: moment().subtract(6, 'days').format(defaultDateFormat),
                    dateTo: moment().format(defaultDateFormat),
                    per_page: 100,
                    page: 1,
                    ...newQuery,
                }
            }, () => {
                this.list_transaction.config({
                    params: {
                        ...this.getParams()
                    }
                }).execute()
            })

        }
    }



}
TransactionList.defaultParams = {
    // query_params:{}
}

export default withRouter(withDomains(TransactionList, "allData"));
